import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../../../shared';
import { GermplasmNameModalComponent, GermplasmNamePopupComponent } from './germplasm-name-modal.component';
import { RouterModule } from '@angular/router';
import { GERMPLASM_NAME_ROUTES } from './germplasm-name.route';
import { GermplasmNameContext } from './germplasm-name.context';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild([...GERMPLASM_NAME_ROUTES]),
    ],
    declarations: [
        GermplasmNameModalComponent,
        GermplasmNamePopupComponent
    ],
    providers: [
        GermplasmNameContext
    ]
})
export class GermplasmNameModule {
}
